import React from "react";
import { motion } from "framer-motion";
import { TrendingUp, User, Award, BookOpen } from "lucide-react";

const PerformanceReportsPage = () => {
  const topStudents = [
    { name: "Rahul Kumar", marks: "98%", batch: "Batch A" },
    { name: "Priya Sharma", marks: "96%", batch: "Batch B" },
    { name: "Amit Singh", marks: "95%", batch: "Batch A" },
  ];

  return (
    <div className="min-h-screen bg-gray-900 p-6">
      <motion.div
        className="max-w-7xl mx-auto space-y-6"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        {/* Header */}
        <div className="flex items-center gap-3">
          <div className="p-3 bg-gradient-to-br from-purple-600 to-indigo-600 rounded-2xl shadow-lg shadow-purple-500/20">
            <TrendingUp className="w-7 h-7 text-white" />
          </div>
          <h1 className="text-4xl font-bold bg-gradient-to-br from-purple-400 to-indigo-400 bg-clip-text text-transparent">
            Performance Reports
          </h1>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-gray-800 rounded-2xl p-6 border border-gray-700">
            <div className="flex items-center gap-3 mb-2">
              <div className="p-2 bg-blue-500/20 rounded-lg">
                <BookOpen className="w-5 h-5 text-blue-400" />
              </div>
              <span className="text-gray-400 text-sm">Average Score</span>
            </div>
            <p className="text-3xl font-bold text-white">78.5%</p>
            <span className="text-green-400 text-xs">+2.5% vs last test</span>
          </div>

          <div className="bg-gray-800 rounded-2xl p-6 border border-gray-700">
            <div className="flex items-center gap-3 mb-2">
              <div className="p-2 bg-green-500/20 rounded-lg">
                <User className="w-5 h-5 text-green-400" />
              </div>
              <span className="text-gray-400 text-sm">Pass Percentage</span>
            </div>
            <p className="text-3xl font-bold text-white">92%</p>
            <span className="text-gray-500 text-xs">Total 450 students</span>
          </div>

          <div className="bg-gray-800 rounded-2xl p-6 border border-gray-700">
            <div className="flex items-center gap-3 mb-2">
              <div className="p-2 bg-yellow-500/20 rounded-lg">
                <Award className="w-5 h-5 text-yellow-400" />
              </div>
              <span className="text-gray-400 text-sm">Top Score</span>
            </div>
            <p className="text-3xl font-bold text-white">98%</p>
            <span className="text-yellow-400 text-xs">
              Rahul Kumar (Batch A)
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Chart Placeholder */}
          <div className="bg-gray-800 rounded-2xl p-6 border border-gray-700 h-80 flex items-center justify-center">
            <p className="text-gray-500">Performance Trend Chart Placeholder</p>
          </div>

          {/* Top Performers */}
          <div className="bg-gray-800 rounded-2xl p-6 border border-gray-700">
            <h3 className="text-lg font-semibold text-white mb-4">
              Top Performers
            </h3>
            <div className="space-y-4">
              {topStudents.map((student, index) => (
                <div
                  key={index}
                  className="flex items-center justify-between p-3 bg-gray-700/50 rounded-xl"
                >
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-full bg-yellow-500/20 text-yellow-500 flex items-center justify-center font-bold">
                      #{index + 1}
                    </div>
                    <div>
                      <p className="text-white font-medium">{student.name}</p>
                      <p className="text-gray-400 text-xs">{student.batch}</p>
                    </div>
                  </div>
                  <span className="text-green-400 font-bold">
                    {student.marks}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default PerformanceReportsPage;
